import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Claim, EASE, MaskedLine, Micro, Reveal, SlideShell } from "../shared";
import { IMG } from "../images";

export default function Slide12Chiusura() {
  return (
    <SlideShell theme="navy" testid="slide-12-chiusura">
      <div className="absolute inset-[-2%]">
        <motion.img
          src={IMG.closing}
          alt="Costa mediterranea vista dall'alto"
          className="h-full w-full object-cover"
          initial={{ scale: 1.12, opacity: 0.6 }}
          animate={{ scale: 1.02, opacity: 1 }}
          transition={{ duration: 2.6, ease: EASE }}
        />
        <div className="absolute inset-0 bg-[#060B19]/60" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#060B19] via-transparent to-[#060B19]/40" />
      </div>

      <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center">
        <Reveal delay={0.3}>
          <img src="/assets/villaflow-mark-light.png" alt="VillaFlow" className="h-16 w-auto sm:h-20" />
        </Reveal>
        <Reveal delay={0.45} className="mt-7">
          <Micro>Investor Deck · 2026</Micro>
        </Reveal>
        <h2 className="mt-7 font-serif text-6xl tracking-tight text-[#FAF7F2] sm:text-7xl lg:text-8xl">
          <MaskedLine delay={0.6}>
            LA <em className="italic text-[#D4AF37]">VISIONE</em>
          </MaskedLine>
        </h2>
        <Reveal delay={0.9} className="mt-9">
          <Claim>Every stay. More value.</Claim>
        </Reveal>
        <Reveal delay={1.1} className="mt-14">
          <a
            data-testid="investor-contact-cta"
            href="mailto:invest@villaflow.it?subject=Investor%20Brief%20VillaFlow"
            className="group inline-flex items-center gap-3 rounded-full border border-[#D4AF37]/50 px-8 py-4 font-mono text-[11px] uppercase tracking-[0.3em] text-[#F3E5AB] transition-colors duration-500 hover:bg-[#D4AF37] hover:text-[#060B19]"
          >
            Richiedi l&rsquo;investor brief
            <ArrowRight size={14} className="transition-transform duration-500 group-hover:translate-x-1" />
          </a>
        </Reveal>
        <Reveal delay={1.25} className="mt-12">
          <span className="font-mono text-[10px] uppercase tracking-[0.35em] text-white/40">
            villaflow.it · Costiera Amalfitana
          </span>
        </Reveal>
      </div>
    </SlideShell>
  );
}
